
<v-dialog
    v-model="touched"
    max-width="480"
>
    <template #activator="{ on, attrs }">
        <slot v-bind="{ on, attrs }"></slot>
    </template>

    <v-card>
        <v-card-title class="customized-primary white--text">
            {{ payload.key }}
        </v-card-title>

        <v-card-text class="pb-0">
            <v-form class="mt-6">
                <v-textarea
                    v-model="value.value"
                    type="text"
                    :label="`${t('translation_title_prefix')} (${payload.locale.toUpperCase()})`"
                    required
                    outlined
                    :error-messages="form.errors.get('value')"
                    :readonly="payload.locale === 'xx'"
                ></v-textarea>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-btn
                color="primary"
                @click="submit"
                width="45%"
                dark
                v-if="payload.locale !== 'xx'"
            >{{ t('general_action_update') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="orange"
                @click="touched = false"
                width="45%"
                dark
            >{{ t('general_action_cancel') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
